import { DamsMediaResourceType, MediaResourceType } from '@/declarations/models/MediaResourceType';

export const DamsDocumentTypeToMediaResourceType: Record<string, MediaResourceType> = {
  Audio: MediaResourceType.AUDIO,
  Modell: MediaResourceType._3D_OBJECT,
  StillImage: MediaResourceType.IMAGE,
  Tabell: MediaResourceType.DOCUMENT,
  Video: MediaResourceType.VIDEO,
};

export const MediaResourceTypeToDamsMediaResourceType: Record<MediaResourceType, DamsMediaResourceType | undefined> = {
  [MediaResourceType._3D_OBJECT]: DamsMediaResourceType.MODEL,
  [MediaResourceType.ANIMATION]: undefined,
  [MediaResourceType.ASSET]: undefined,
  [MediaResourceType.AUDIO]: DamsMediaResourceType.AUDIO,
  [MediaResourceType.CARD]: undefined,
  [MediaResourceType.DOCUMENT]: DamsMediaResourceType.DOCUMENT,
  [MediaResourceType.FORM]: undefined,
  [MediaResourceType.IMAGE]: DamsMediaResourceType.IMAGE,
  [MediaResourceType.LOCATION]: undefined,
  [MediaResourceType.PAGE]: undefined,
  [MediaResourceType.PERSON]: undefined,
  [MediaResourceType.SYSTEM_IMAGE]: undefined,
  [MediaResourceType.TABLE]: DamsMediaResourceType.TABLE,
  [MediaResourceType.VIDEO]: DamsMediaResourceType.VIDEO,
};
